export default __webpack_public_path__ + "static/media/AnimalFeaturesHorns_01.6504d239.png";